/**
 * Texte der Version 9, geschrieben für Recruiter:innen und HR-Teams.
 * Pro Station eine Headline und zwei kurze Punkte. `n` sind die Zahlen,
 * die oben im Rechner eingestellt wurden.
 */

const de = (v) => Math.round(v).toLocaleString('de-DE')

export const STEPS = {
  hr: {
    title: 'Neue Stelle. Kein leeres Blatt.',
    points: () => [
      'Starte mit einer Aivy-Vorlage für die Rolle.',
      'Oder hol die Fachbereiche direkt dazu, gern auch beides.'
    ]
  },
  analyse: {
    title: 'Der Fachbereich sagt, was zählt.',
    points: () => [
      'Jede Person schätzt die Anforderungen selbst ein, in wenigen Minuten.',
      'Du sparst dir lange Abstimmungsrunden.'
    ]
  },
  profil: {
    title: 'Ein Profil, hinter dem alle stehen.',
    points: () => [
      'Aivy berechnet daraus Ideal- und Übergangsbereiche.',
      'Nach den Best Practices der DIN 33430.'
    ]
  },
  link: {
    title: 'Ein Link für alle Kanäle.',
    points: () => [
      'Einladungslink und QR-Code für Anzeige, Karriereseite, Social Media oder Messe.',
      'Mit Aivy® Attract sehen Talente sofort, welche eurer Stellen passt.'
    ]
  },
  games: {
    title: 'Spielen statt Fragebogen.',
    points: () => [
      'Kurze Spiele am Smartphone oder im Web, wann es den Talenten passt.',
      'Gemessen wird Verhalten, keine Selbstbeschreibung.'
    ]
  },
  talente: {
    title: 'Candidate Experience inklusive.',
    points: () => [
      'Alle bekommen ihr persönliches Stärkenprofil, auch bei einer Absage.',
      'Das zahlt auf euer Employer Branding ein.'
    ]
  },
  liste: {
    title: 'Du startest mit einer sortierten Liste.',
    points: (n) => [
      `Statt ${de(n.apps)} Lebensläufe einzeln zu lesen, siehst du die Passung aller auf einen Blick.`,
      'Die Entscheidung triffst weiterhin du.'
    ]
  },
  magic: {
    title: 'So entsteht die Passung.',
    points: () => [
      'Aus dem Spielverhalten werden validierte Dimensionen.',
      'Die gleicht Aivy mit dem Anforderungsprofil ab.'
    ]
  },
  regeln: {
    title: 'Erklärbar, auch gegenüber dem Fachbereich.',
    points: () => [
      'Im Kern regelbasiert, ohne Blackbox.',
      'Jedes Ergebnis lässt sich bis auf die einzelne Dimension begründen.'
    ]
  },
  report: {
    title: 'Alles für die Entscheidung in einem PDF.',
    points: () => [
      'Das Passungsprofil mit Chancen, Risiken und Interviewfragen.',
      'Der Aivy Assistent beantwortet Rückfragen direkt.'
    ]
  },
  gespraech: {
    title: 'Bessere Interviews, weniger Vorbereitung.',
    points: () => [
      'Aivy schlägt Fragen passend zum Profil der Person vor.',
      'Du gehst gezielt auf die Punkte, die sich zu vertiefen lohnen.'
    ]
  },
  team: {
    title: 'Passt die Person auch ins Team?',
    points: () => [
      'Die Teamanalyse zeigt, welche Stärken im Team stecken.',
      'Mit Talent vergleichen zeigt, wer ergänzt, was noch fehlt.'
    ]
  },
  kreuz: {
    title: 'Gute Leute nicht verlieren.',
    points: () => [
      'Passt jemand nicht auf diese Stelle, prüft das Kreuzmatching eure anderen.',
      'Ohne neues Assessment.'
    ]
  },
  absagen: {
    title: 'Absagen, die du begründen kannst.',
    points: () => [
      'Gleiche Kriterien für alle, datenbasiert und nachvollziehbar.',
      'Das gibt dir Sicherheit, auch rechtlich.'
    ]
  },
  ats: {
    title: 'Alles in deinem ATS.',
    points: () => [
      'Mit dem Sidebar-Plugin hast du Auswertung und Assistent direkt dort.',
      'Zum Beispiel in softgarden, Personio oder Workday.'
    ]
  },
  support: {
    title: 'Und wenn mal eine Frage offen ist?',
    points: () => [
      'Unser Support hilft schnell und persönlich.',
      'Per Mail an help@aivy.app oder im kurzen Call.'
    ]
  }
}

export const hoursOf = (n) => (n.jobs * n.apps * n.minutes) / 60

export { de }
